<template>
  <v-container
    fill-height
    fluid
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="8"
      >
        <material-card title="Welcome">
          <v-form>
            <v-container class="py-0">            
              <v-row>
                <v-col
                  cols="12"
                  class="text-left"
                >
                  <v-card>
                    <v-card-title>User name</v-card-title>
                    <v-card-text>{{ userName }}</v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  class="text-right"
                >
                  <v-btn color="primary" class="sr_gray--text" v-on:click="signOut()">Sign Out</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </material-card>
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    methods: {
      async signOut() {
        this.$store.dispatch("signOut")
        .then( ignore => {
          void(ignore)
          this.$router.push("/");
        });
      }
    },
    computed: {
      userName() { 
        return this.$store.state.userInfo.getUsername();
      },
    }

  }
</script>
